var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/IconAwardCheck.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var IconAwardCheck = function IconAwardCheck(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    viewBox: "20 25 105 105",
    fill: "none",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100",
    height: "100",
    fill: "none",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.18 54.45v70.33l16.07-17.28 17.37 17.68V54.86l-33.44-.41z",
    fill: "#f2a619",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.81 29.82a32.24 32.24 0 0 0-29.821 19.868 32.24 32.24 0 0 0 6.957 35.152 32.24 32.24 0 0 0 35.141 7.011A32.24 32.24 0 0 0 104 62.06a32.24 32.24 0 0 0-32.19-32.24z",
    fill: "#ffd237",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 54.06L68.46 77a2.91 2.91 0 0 1-2.12.917A2.91 2.91 0 0 1 64.22 77L54.05 65.69a3.19 3.19 0 0 1 0-4.35 2.85 2.85 0 0 1 2.07-.891 2.85 2.85 0 0 1 2.07.891l8.15 9.23 18.5-20.85a2.84 2.84 0 0 1 2.075-.901 2.84 2.84 0 0 1 2.075.901 3.18 3.18 0 0 1 .01 4.34z",
    fill: "#fff",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 9
    }
  }));
};

IconAwardCheck.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
IconAwardCheck.defaultProps = {
  className: null
};
export default IconAwardCheck;